import { useOrganizationContextInvalid } from "@/modules/organization/organization-context";

import { ObservationPage } from "./observation-page.component";

export const ObservationPageWrapper = () => {
  const { isInvalid } = useOrganizationContextInvalid();

  // If context is invalid, return nothing because the background
  // page (observations list) is already displaying the error page
  if (isInvalid) return null;

  return <ObservationPage />;
};
